<script>
  // import {createEventDispatcher} from 'svelte'
  import {basket,open} from "./basket-store.js"
  import Currency from "./currency.svelte"
  export let productid 
  export let price="0.00"
  export let currency = null
  let qty = 1
  // const dispatch = createEventDispatcher()
  function add(){
    basket.add({id:productid, qty: ""+qty})
    $open = true
  }
</script>

<style>
  .buy{
    display:flex;
    width:180px;
    margin:5px;
  }
  input,button{
    padding:8px 10px;
    font-size:14px;
    border:1px solid var(--s-primary,#444);
  }
  input{
    width:50px;
    border-radius:5px 0 0 5px;
    text-align: center;
  }
  button{
    flex:100;
    background:#2299ee;
    background:var(--s-primary,#444);
    color:white;
    border-radius:0 5px 5px 0;
  }
  button:hover{
    box-shadow: inset 0 0 100px rgba(0,0,0,0.1)
  }
</style>

<div class="buy">
  <input type="number" name="qty" bind:value={qty} />
  <button on:click={add} > Buy <Currency currency={currency || "GBP"} value={price}></Currency></button>
</div>